"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TransactionStatus = exports.TxnPendingStates = exports.TransactionStore = void 0;
const immutable_1 = require("immutable");
const core_1 = require("companion-app-components/flux/core");
exports.TransactionStore = (0, immutable_1.Record)(Object.assign(Object.assign({}, core_1.resourceStoreTypes.mkQcsSyncResourceStore().toObject()), { lastReductions: null }));
exports.TxnPendingStates = {
    QCS_REFRESH_BANK_PENDING: 'QCS_REFRESH_BANK_PENDING',
    QCS_BATCH_REFRESH_BANK_PENDING: 'QCS_BATCH_REFRESH_BANK_PENDING',
    USER_OWNED_BANK_PENDING: 'USER_OWNED_BANK_PENDING',
    REAL_TIME: 'REAL_TIME',
    USER_OWNED_REAL_TIME_BANK_PENDING: 'USER_OWNED_REAL_TIME_BANK_PENDING',
};
exports.TransactionStatus = {
    RECONCILED: 'RECONCILED',
    CLEARED: 'CLEARED',
    PENDING: 'PENDING',
};
